import { MODULE } from "./splitOrders.actionTypes";

export const isFetchingStatus = (state) => state.getIn([MODULE, "isFetchingStatus"]);

export const isSavingStatus = (state) => state.getIn([MODULE, "isSavingStatus"]);

export const isConfirmationModalVisible = (state) =>
  state.getIn([MODULE, "isConfirmationModalVisible"]);

export const getProducts = (state) => state.getIn([MODULE, "products"]);
